<template>
  <div class="notice-container" :style="{'width': width}">
    <div class="notice">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'notice',
  props: ['text'],
  data: function () {
    return {
    }
  },
  computed: {
    width() {
      // return '100%'
      return ((100 - (1 / 2048) * Math.pow(this.text.length - 360, 2)) * 3.6) + 'px'
    },
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
@import "@/style/settings.scss";

.notice-container {
  position: relative;
  max-width: 100%;
  min-width: 50%;
  width: 60%;
  margin-left: auto;
  margin-right: auto;
  &:before{
    content: "";
    display: block;
    padding-top: 100%;
  }
}

.notice {
  position: absolute;
  top: 0;
  left: 0;
  // bottom: 0;
  // right: 0;
  margin: 10px 10px 30px;
  padding: 20px;
  border:1px solid #E8E8E8;
  font-family: 'Architects Daughter', 'cursive';
  font-size: 18px;
  text-align: center;
  text-shadow: none;
  color: lighten(#015, 10%);
  border-bottom-right-radius: 60px 6px;
  box-shadow: 2px 10px 7px rgba(0, 0, 0, 0.5);
  // overflow:hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  white-space: pre-wrap;
  background-image: linear-gradient(to top left, #FFFFD6 0px, #FFFF88 60px);
  transform: rotate(-3deg);
  textarea {
    background: none;
    border: 1px dotted black;
    width: 100%;
    height: 2em;
    text-align: center;
    resize: none;
    &:focus {
      border: none;
      outline: none;
    }
  }
}
</style>
